((Drupal) => {
  Drupal.behaviors.paragraph_split_layout = {
    attach(context) {
      once("paragraph_split_layout", "body", context).forEach(() => {
        const leftElFieldItems = Array.from(
          document.querySelectorAll(".homepage-split-left-item")
        );
        const rightElFieldItems = Array.from(
          document.querySelectorAll(".homepage-split-right-item")
        );
        const groupedArray = leftElFieldItems
          .map((value, index) => {
            return [value, rightElFieldItems[index]];
          })
          .filter((groupedElement) => {
            return groupedElement.length === 2;
          });

        groupedArray.forEach((groupedElements) => {
          const left = groupedElements[0];
          const right = groupedElements[1];
          const upstreamClasses = ["remove-bottom-margin"];
          if (left.nextElementSibling === right) {
            const homepageGridContainer = document.createElement("div");
            homepageGridContainer.classList.add(
              "homepage-cols-2",
              "paragraph-container",
              "hbn-split-layout"
            );
            upstreamClasses.forEach((upstreamClass) => {
              if (
                left.classList.contains(upstreamClass) ||
                right.classList.contains(upstreamClass)
              ) {
                homepageGridContainer.classList.add(upstreamClass);
              }
            });
            left.insertAdjacentElement("beforebegin", homepageGridContainer);
            homepageGridContainer.appendChild(left);
            homepageGridContainer.appendChild(right);
          }
        });
      });
    },
  };
})(Drupal);
